import { ClientType } from "constants/client";
import { ToggleKey } from "constants/toggles";
import type { ToggleFeature } from "./types";

class ToggleUtils {
  isToggleActive(
    toggles: ToggleFeature[] | null | undefined,
    feature: ToggleKey
  ): boolean {
    if (toggles == null) {
      return false;
    }

    return toggles.some((toggle) => toggle.Nome === feature && toggle.Ativo);
  }

  isScoreAdjustmentActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.SemiConfinement);
  }

  isDrumCollectionActive(toggles: ToggleFeature[] | null | undefined): boolean {
    return this.isToggleActive(toggles, ToggleKey.DrumCollection);
  }

  isFormulationRegistrationActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.FormulationRegistration);
  }

  isCauseOfDeathRegistrationActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.CauseOfDeathRegistration);
  }

  isCreepActive(toggles: ToggleFeature[] | null | undefined): boolean {
    return this.isToggleActive(toggles, ToggleKey.Creep);
  }

  isConsumptionClosureActive(
    toggles: ToggleFeature[] | null | undefined,
    selectedClientType: ClientType | null | undefined
  ): boolean {
    const isLiteClient = selectedClientType === ClientType.Lite;
    return (
      !isLiteClient &&
      this.isToggleActive(toggles, ToggleKey.ConsumptionClosure)
    );
  }

  isDeathsAndBirthsActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.DeathsAndBirths);
  }

  isWeightGainRegistrationActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.WeightGainRegistration);
  }

  isRainActive(toggles: ToggleFeature[] | null | undefined): boolean {
    return this.isToggleActive(toggles, ToggleKey.Rain);
  }

  isLotGoalRegistrationActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.LotGoalRegistration);
  }

  isCategorySwapActive(toggles: ToggleFeature[] | null | undefined): boolean {
    return this.isToggleActive(toggles, ToggleKey.CategorySwap);
  }

  isProjectedWeightColumnActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.ProjectedWeightColumn);
  }

  isSanityCollectionActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.SanityCollection);
  }

  isForageCycleManagementActive(
    toggles: ToggleFeature[] | null | undefined
  ): boolean {
    return this.isToggleActive(toggles, ToggleKey.ForageCycleManagement);
  }
}

const toggleUtils = new ToggleUtils();

export default toggleUtils;
